// Query key factory for the campaign sync workspace lead list/detail.
export type SyncLeadFilters = {
  campaign_id: number
  grade?: string
  q?: string
  sort?: string
  dir?: string
  page?: number
  page_size?: number
}

export const syncLeadKeys = {
  all: ["autoleads", "sync-leads"] as const,
  list: (filters: SyncLeadFilters) =>
    [...syncLeadKeys.all, "list", filters] as const,
  detail: (leadId: number) => [...syncLeadKeys.all, "detail", leadId] as const,
}
